import { container } from '@/container';
import { MODAL_NAMES__EPOS } from '@/epos/vue/modals/MODAL_NAMES__EPOS';
import { suppressModalCancelledErrorOrReThrow } from '@/lib/Errors';

export const SendOrderEmailReceiptMixin = {
    data() {
        return {
            emailReceiptSent: false,
        };
    },

    computed: {
        /**
         * @return {boolean}
         */
        emailReceiptButtonVisible() {
            return !!this.$store.state.isOnline;
        },
    },

    methods: {
        /**
         * Handle a click on a button to send an email receipt.
         * If the receipt has already been sent this will prompt the user if they want to send it again.
         */
        emailReceipt() {
            if (!this.emailReceiptSent) {
                // Receipt hasn't already been sent.
                this._emailReceipt();
                return;
            }

            container.dialogService
                .confirm('ORDER_PRINTING.CONFIRM_RESEND_RECEIPT')
                .then((confirmed) => {
                    if (confirmed) {
                        // Receipt has already been sent, but operator says send it again.
                        this._emailReceipt();
                    }
                });
        },

        /**
         * @private
         */
        _emailReceipt() {
            container.vueModalFactory
                .open(
                    MODAL_NAMES__EPOS.ORDER_EMAIL_RECEIPT,
                    {
                        order: this.order,
                        originalOrderID: (this.originalOrder ? this.originalOrder.ID : null),
                    },
                )
                .then(() => {
                    this.emailReceiptSent = true;
                })
                .catch(suppressModalCancelledErrorOrReThrow);
        },
    },
};
